import axios_c_low from "src/service/HomePageContentAPICall/axios_c_low";
import $ from "jquery";
import System from "../helper/system";
import Product from "@system/config/product";
import ResponseMaker from "./ProductListingAPICall/responseMaker";
import { isArray } from "underscore";
import Helper from "src/support/Helper";

const speedBoat = (System.auth('speedBoat') === 'T' ? 'Abacus' : System.auth('speedBoat') === 'B' ? 'EBV' : 'Silica')

class EssentialContentAPICall {
    getManufacturersListBySearchParam = async (searchParam = '*') => {
        const config = {
            method: 'POST',
            url: Product.PRODUCT_LISTING,
            headers: Helper.getCommonHeader('POST'),
            data: {
                "filter": "Sboat eq '" + System.auth('speedBoat') + "'",
                "isIncludeCount": true,
                "isSkipFacets": false,
                "search": searchParam + "*",
                "orderby": "ManufacturerPartNumber asc",
                "skip": 0,
                "top": 0,
                "searchColumns": [],
                "facetsTypes": ["GlobalSearchManufacturer"]
            }
        };
        let res = {};
        await axios_c_low(config)
            .then(function (response) {
                res.data = response.data.Data;
            });
        return new ResponseMaker(res).process().run().get();
    };

    getCategoriesListBySearchParam = async (searchParam = '*') => {
        const config = {
            method: 'POST',
            url: Product.PRODUCT_LISTING,
            headers: Helper.getCommonHeader('POST'),
            data: {
                "filter": "Sboat eq '" + System.auth('speedBoat') + "'",
                "isIncludeCount": true,
                "isSkipFacets": false,
                "search": searchParam + "*",
                "orderby": "ManufacturerPartNumber asc",
                "skip": 0,
                "top": 0,
                "searchColumns": [],
                "facetsTypes": ["GlobalSearchCategory"]
            }
        };
        let res = {};
        await axios_c_low(config)
            .then(function (response) {
                res.data = response.data.Data;
            });
        return new ResponseMaker(res).process().run().get();
    };

    getDocumentsListBySearchParam = async (searchParam = '*') => {
        let param = {
            contentType: 'other',
            searchTerm: searchParam,
            mediatype: 'docs',
        };
        let res = {};
        await this.axiosCall(Product.AUTOSUGGEST_LISTING_BY_SEARCH_PARAM, {
            ...param
        }, 'GET', false, false, false, true).then(function (response) {
            res.data = {}
            res.data['Documents'] = response.data
        }).catch(e => {
            // res.data = {}
            // res.data['Documents'] = documentFakeResponse()
        });
        return new ResponseMaker(res).process().run().get();
    };

    axiosCall = async (url, data = {}, method = 'get', skipParams = false, isBlob = false, isAllVideo = false, isOld = false) => {
        let params = {
            store: 'emea',
            selectedSpeedBoat: speedBoat,
            profileName: 'Avn_fspFindWebContentBySearchTerm',
            ...data
        }

        if (isOld) {
            params = {
                responseFormat: 'json',
                profileName: isAllVideo ? Product.autosuggest_param('profileVideo') : Product.autosuggest_param('profileName'),
                contentType: 'others',
                storeId: Product.autosuggest_param('storeId'),
                catalogId: Product.autosuggest_param('catalogId'),
                langId: Product.autosuggest_param('langId'),
                currency: window.mct,
                orgEntityId: Product.autosuggest_param('orgEntityId'),
                contractId: Product.autosuggest_param('contractId'),
                wt: Product.autosuggest_param('wt'),
                '_wcf.search.expr': data.searchTerm,
                userAction: true,
                selectedSpeedBoat: speedBoat,
                ...data
            };
        }

        let paramsToSend = $.param(params);
        let filterBy = [];
        if (params.filterBy !== undefined && isArray(params.filterBy) && params.filterBy.length > 0) {
            filterBy = params.filterBy;
            delete params.filterBy;
        }
        if (filterBy.length > 0) {
            paramsToSend = $.param(params);
            let paramsURLFilterBy = new URLSearchParams();
            filterBy.map((v) => {
                paramsURLFilterBy.append("filterBy", v);
            });
            paramsURLFilterBy = paramsURLFilterBy.toString();
            paramsToSend = paramsToSend + "&" + paramsURLFilterBy;
        }
        let config = {
            method: method,
            url: url + "?" + paramsToSend,
        };
        if (isAllVideo && config['contentType'] !== undefined && config['contentType'] !== null) {
            delete config.params['contentType'];
        }

        return axios_c_low(config);
    };
}

export default EssentialContentAPICall;